import { Button, Checkbox, FormControlLabel, Grid, InputAdornment, TextField, Typography, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import axios from "../../../axios/AxiosInterceptors";
import { onError } from "../../../store/actions/popupActions";
import TransactionComments from "./TransactionComments";
import TransactionEvents from "./TransactionEvents";

const useStyles = makeStyles((theme) => ({
    offset: theme.mixins.toolbar,
    layout: {
        width: 'auto',
        marginTop: theme.spacing(10),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
            width: 1200,
            marginLeft: 'auto',
            marginRight: 'auto',
        }
    },
    paper: {
        width: 'auto',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(5),
    },
    table: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    tableRow: {
        "&:hover": {
            cursor: 'pointer'
        }
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    }
}));

const ReplacementTransaction = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const params = useParams();
    const history = useHistory();
    const [transaction, setTransaction] = useState();

    useEffect(() => {
        retrieveReplacementTransaction();
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const retrieveReplacementTransaction = async () => {
        await trackPromise(axios.get("/capacity/account/" + params.accountId + "/transactions/replacement/" + params.transactionId).then(response => {
            setTransaction(response.data);
        }).catch(error => {
            dispatch(onError(error));
        }));
    }

    return (
        <main className={classes.layout}>
            {transaction &&
                <React.Fragment>
                    <Typography variant="h5" align="center" style={{ marginBottom: 50 }}>{transaction.companyName} Replacement Transaction {transaction.transactionId}</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={1} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.startDate} disabled={true} label="Start Date" fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={1} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.endDate} disabled={true} label="Stop Date" fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={1} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.status} disabled={true} label="Status" fullWidth />

                        </Grid>
                        <Grid item xs={6} sm={1} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.resourceName} disabled={true} label="Resource Name" fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={1} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.replacementResourceName} disabled={true} label="Replacement Resource Name" fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={1} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.capacityMw} disabled={true} label="Capacity" fullWidth InputProps={{
                                endAdornment: <InputAdornment position="start">MWs</InputAdornment>,
                            }} />
                        </Grid>
                        <Grid item xs={6} sm={1} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.productType} disabled={true} label="Product Type" fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={1} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.replacementProductType} disabled={true} label="Replacement Product Type" fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={1} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.replacementLdaName} disabled={true} label="Replacement LDA Name" fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={1} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.commitmentMoprType ? transaction.commitmentMoprType : ''} disabled={true} label="Commitment MOPR Type" fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={1} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.replacementMoprType ? transaction.replacementMoprType : ''} disabled={true} label="Replacement MOPR Type" fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={1} />
                        <Grid item xs={6} sm={3}>
                            <TextField value={transaction.bilateralReplacement ? transaction.bilateralReplacement : ''} disabled={true} label="Bilateral Replacement" fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={5} />
                        <Grid item xs={6} sm={4}>
                            <FormControlLabel control={<Checkbox name="forPah" checked={transaction.pah ? transaction.pah : false} disabled={true} />} label="For PAH" />
                        </Grid>
                        <Grid item xs={6} sm={3} />
                    </Grid>
                    <TransactionEvents accountId={transaction.accountId} transactionType="replacement" transactionId={transaction.transactionId} />
                    <TransactionComments accountId={transaction.accountId} transactionType="capmod" transactionId={transaction.transactionId} />
                </React.Fragment>
            }
            <Grid container spacing={2}>
                <Grid item xs={6} sm={4} />
                <Grid item xs={6} sm={4}>
                    <Button fullWidth onClick={() => history.goBack()} style={{ marginTop: 50 }}>Back</Button>
                </Grid>
                <Grid item xs={6} sm={4} />
            </Grid>
        </main>
    );

}

export default ReplacementTransaction;